import {SessionInfoTable, SessionInfoTableRow} from 'module/SessionInfo/component/modal/SessionInfoTable';
import React from 'react';

interface Props {
	kostInfo: {
		baseBewEinh: string | null
		currentBewEinh: string | null
		empfEinh: string | null
	}
}

export const KostComponent = React.memo<Props>(({kostInfo}) => {
	const {baseBewEinh, currentBewEinh, empfEinh} = kostInfo;
	return (
		<SessionInfoTable>
			{baseBewEinh &&
			<SessionInfoTableRow label={'Stammkostenstelle'}>
				{baseBewEinh}
			</SessionInfoTableRow>
			|| null
			}
			{currentBewEinh &&
			<SessionInfoTableRow label={'Kostenstelle'}>
				{currentBewEinh}
			</SessionInfoTableRow>
			|| null
			}
			{empfEinh &&
			<SessionInfoTableRow label={'Auftrag/Projekt'}>
				{empfEinh}
			</SessionInfoTableRow>
			|| null
			}
		</SessionInfoTable>
	);
});
